import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { PrimaryButton } from "../../components/button";
import { Widget } from "../../components/widget";
import { flags, useLanguages } from "../../i18n";
import { mapObject } from "../../utils/utils";

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  & > * {
    margin: 0.5em;
  }
`;

export const LangaugePicker: React.FunctionComponent<{}> = () => {
  const { languages, selectLanguage } = useLanguages();
  const { t } = useTranslation("fields");

  return (
    <Widget title={t("language")}>
      <Container>
        {mapObject(languages, (val, key) => (
          <PrimaryButton
            variant="outlined"
            disabled={key !== "en-GB"}
            onClick={() => selectLanguage(key)}
            key={key}
          >
            <>
              {flags[key]} {val.nativeName}
            </>
          </PrimaryButton>
        ))}
      </Container>
    </Widget>
  );
};
